var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeedometer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 85,
    viewBox: "0 0 84 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.646973,
    width: 84,
    height: 84,
    rx: 10,
    fill: "url(#paint0_linear_10_7645)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7107 23.668C35.7416 23.9532 31.0818 25.8841 27.3623 29.199L33.1146 34.9513C35.2794 33.1491 37.9079 32.06 40.7107 31.8039V23.668Z",
    fill: "#00B2E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2913 36.7737L25.539 31.0215C22.2213 34.7399 20.288 39.4001 20.001 44.3704H28.1373C28.3951 41.567 29.4865 38.9383 31.2913 36.7737Z",
    fill: "#00B2E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.863 44.3704H63.9993C63.7123 39.4001 61.779 34.7399 58.4612 31.0215L52.709 36.7737C54.5138 38.9382 55.6052 41.567 55.863 44.3704Z",
    fill: "#00B2E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8611 46.9485C55.6804 48.9339 55.1138 50.5899 54.4437 51.9183C55.0974 52.9264 55.6424 53.7784 56.0025 54.3442C56.9831 55.8852 56.766 57.8633 55.4745 59.1549C55.1609 59.4685 54.8027 59.7211 54.4146 59.9079L55.7542 61.2476C56.0064 61.4998 56.3369 61.6258 56.6673 61.6258C56.9978 61.6258 57.3283 61.4998 57.5803 61.2476C61.441 57.3874 63.6921 52.3502 64.0002 46.9485H55.8611Z",
    fill: "#00B2E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1391 46.9485H20C20.3081 52.3502 22.5592 57.3874 26.4198 61.2477C26.6719 61.4999 27.0024 61.6259 27.3328 61.6259C27.6632 61.6259 27.9937 61.4998 28.2459 61.2477L32.1571 57.3363C32.6613 56.832 32.6613 56.0144 32.1571 55.5101C31.1364 54.4894 28.5654 51.6318 28.1391 46.9485Z",
    fill: "#00B2E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6375 29.199C52.918 25.884 48.2581 23.9532 43.2891 23.668V31.8039C46.0918 32.06 48.7204 33.1491 50.8852 34.9513L56.6375 29.199Z",
    fill: "#00B2E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8644 42.8168C43.2851 41.2375 40.7154 41.2375 39.1361 42.8168C37.5568 44.3961 37.5568 46.9658 39.1361 48.545C41.1312 50.5402 50.9363 56.8007 52.0478 57.508C52.5575 57.8324 53.2241 57.7592 53.6514 57.332C54.0786 56.9048 54.1518 56.2382 53.8274 55.7284C53.12 54.6169 46.8595 44.8118 44.8644 42.8168Z",
    fill: "#00B2E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_7645",
    x1: 42,
    y1: 0.646973,
    x2: 42,
    y2: 84.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FD0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer);
export default __webpack_public_path__ + "static/media/speedometer.b16d414bff7acb8027f918d9dfced5d7.svg";
export { ForwardRef as ReactComponent };